function PortfolioFooter({
  current,
  total,
  onPrev,
  onNext,
  likes,
  onLike,
  onContact,
  theme,
  toggleTheme
}) {
  return (
    <div className="portfolio-footer">

      {/* Theme */}
      <button className="footer-btn theme-btn" onClick={toggleTheme}>
        {theme === "dark" ? "🌙 Dark" : "☀️ Light"}
      </button>

      {/* Navigation */}
      <div className="footer-nav">
        <button className="footer-btn" onClick={onPrev}>◀</button>
        <span>{current} / {total}</span>
        <button className="footer-btn" onClick={onNext}>▶</button>
      </div>

      {/* Likes */}
      <button className="footer-btn like-btn" onClick={onLike}>
        ❤️ {likes}
        

      </button>

      {/* Contact */}
      <button className="footer-btn contact-btn" onClick={onContact}>
        ✉️ Contact
      </button>

    </div>
    
  );
}

export default PortfolioFooter;
